import { IconProps } from "../../utils/global-types/global-types";

const ScheduledIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M9 1.708C4.982 1.708 1.708 4.982 1.708 9S4.982 16.292 9 16.292 16.292 13.018 16.292 9 13.018 1.708 9 1.708m3.172 9.895a.544.544 0 0 1-.751.19l-2.26-1.35c-.562-.335-.978-1.071-.978-1.72v-2.99a.55.55 0 0 1 .547-.547.55.55 0 0 1 .547.547v2.99c0 .262.219.649.445.78l2.26 1.35a.54.54 0 0 1 .19.75"
      ></path>
    </svg>
  );
};

export default ScheduledIcon;
